
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookies_accepted', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-2xl px-4"
      style={{ fontFamily: 'Sora, sans-serif' }}
    >
      <div className="bg-[#0F0F1E] border border-white/[0.08] rounded-xl shadow-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icon */}
        <div className="w-9 h-9 flex items-center justify-center shrink-0 bg-[#7B3FE4]/10 rounded-lg">
          <i className="ri-cookie-line text-[#7B3FE4] text-lg"></i>
        </div>

        {/* Text */}
        <p className="text-[#8887A0] text-[13px] leading-relaxed flex-1">
          Usamos cookies para mejorar tu experiencia. Al continuar navegando, aceptas nuestra{' '}
          <Link
            to="/politica-de-privacidad"
            className="text-[#7B3FE4] hover:text-[#9B6FF4] underline underline-offset-2 transition-colors duration-200 cursor-pointer"
          >
            Política de Privacidad
          </Link>
          .
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className="text-[#8887A0] hover:text-[#F0EFF8] text-[13px] font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer px-3 py-1.5"
          >
            Rechazar
          </button>
          <button
            onClick={handleAccept}
            className="bg-[#7B3FE4] hover:bg-[#6B2FD4] text-white text-[13px] font-semibold px-5 py-2 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
